(() => {
  const headers = document.querySelectorAll('[data-calinfi-header]');
  const accessoryLinksByLabel = new Map(
    Object.entries({
      'all pipes': '/collections/stove-pipes',
      'all peels & kits': '/collections/pizza-peels',
      'spare parts': '/collections/spare-parts',
      'flue pipe elbow 90° 80mm [odun ls / odun]': '/products/flue-pipe-elbow-90deg-80mm?view=accessory',
      'flue pipe elbow 45° 80mm [odun ls / odun]': '/products/flue-pipe-elbow-45deg-80mm?view=accessory',
      'flue pipe straight 80mm [odun ls / odun]': '/products/flue-pipe-straight-80mm?view=accessory',
      'chimney pipe 80mm [odun ls / odun]': '/products/spark-arrestor-80mm?view=accessory',
      'flue pipe elbow 90° 60mm [odun s]': '/products/flue-pipe-elbow-90deg-60mm?view=accessory',
      'flue pipe elbow 45° 60mm [odun s]': '/products/flue-pipe-elbow-45deg-60mm?view=accessory',
      'flue pipe straight 60mm [odun s]': '/products/flue-pipe-straight-60mm?view=accessory',
      'chimney pipe 60mm [odun s]': '/products/spark-arrestor-60mm?view=accessory',
      'pizza peel small': '/products/pizza-peel-small?view=accessory',
      'pizza peel large': '/products/pizza-peel-large?view=accessory',
      'pizza stone s': '/products/pizza-stone-s?view=accessory',
      'pizza stone': '/products/pizza-stone?view=accessory',
      'pizza cutting board': '/products/pizza-cutting-board?view=accessory',
      'pellet kit': '/products/pellet-kit?view=accessory',
      'resistant mat': '/products/heat-resistant-mat?view=accessory',
      'modular cast iron grill': '/products/modular-cast-iron-grill?view=accessory',
      'grill tongs': '/products/grill-tongs?view=accessory',
      'carry bag for odun ls / odun': '/products/carry-bag-for-odun-odun-ls?view=accessory',
      'carry bag for odun s': '/products/carry-bag-for-odun-s?view=accessory',
      'main glass': '/products/main-glass?view=accessory',
      'main glass s': '/products/main-glass-s?view=accessory',
      'oven glass': '/products/oven-glass?view=accessory',
      'oven glass s': '/products/oven-glass-s?view=accessory',
      'modular handle': '/products/modular-handle?view=accessory',
      'water bottle': '/products/water-boiler-for-odun?view=accessory',
    }),
  );

  if (!headers.length) return;

  const normalizeAccessoryLinks = (header) => {
    const panel = header.querySelector('[data-calinfi-mega-panel="accessories"]');
    if (!panel) return;

    panel.querySelectorAll('a').forEach((link) => {
      const label = link.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
      const target = accessoryLinksByLabel.get(label);
      if (target) link.setAttribute('href', target);
    });
  };

  const normalizeStoveLinks = (header) => {
    const panel = header.querySelector('[data-calinfi-mega-panel="odun"]');
    if (!panel) return;

    const productLinksByLabel = new Map(
      Object.entries({
        'odun ls': '/products/odun-ls?view=odun-ls-v6',
        odun: '/products/odun?view=odun-launch-v6',
        'odun s': '/products/odun-s?view=odun-s-preorder-v6',
      }),
    );

    panel.querySelectorAll('.calinfi-header__mega-product').forEach((link) => {
      const title = link.querySelector('.calinfi-header__mega-product-title');
      const label = title?.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
      const target = productLinksByLabel.get(label);
      if (target) link.setAttribute('href', target);
    });
  };

  headers.forEach((header) => {
    normalizeAccessoryLinks(header);
    normalizeStoveLinks(header);

    const hero = header.matches('[data-homepage-hero-header="true"]')
      ? document.querySelector('.calinfi-hero-product')
      : null;
    const triggers = header.querySelectorAll('[data-calinfi-mega-trigger]');
    const panels = header.querySelectorAll('[data-calinfi-mega-panel]');
    let activeMenu = null;
    let closeTimer = null;

    const updateHeaderState = () => {
      if (!hero) return;

      const threshold = header.offsetHeight + 1;
      const heroBottom = hero.getBoundingClientRect().bottom;
      header.classList.toggle('calinfi-header--hero-active', heroBottom > threshold);
    };

    const setPanelInert = (panel, isInert) => {
      panel.toggleAttribute('inert', isInert);
      panel.setAttribute('aria-hidden', String(isInert));
    };

    const closeMega = () => {
      activeMenu = null;
      header.classList.remove('calinfi-header--mega-open');

      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      panels.forEach((panel) => {
        panel.classList.remove('is-open');
        setPanelInert(panel, true);
      });
    };

    const openMega = (menuName) => {
      if (!menuName) return;

      clearTimeout(closeTimer);
      activeMenu = menuName;
      header.classList.add('calinfi-header--mega-open');

      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', String(trigger.dataset.calinfiMegaTrigger === menuName));
      });

      panels.forEach((panel) => {
        const isOpen = panel.dataset.calinfiMegaPanel === menuName;
        panel.classList.toggle('is-open', isOpen);
        setPanelInert(panel, !isOpen);
      });
    };

    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMega, 120);
    };

    updateHeaderState();

    if (hero) {
      window.addEventListener('scroll', updateHeaderState, { passive: true });
      window.addEventListener('resize', updateHeaderState);
    }

    if (!triggers.length || !panels.length) return;

    triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => openMega(trigger.dataset.calinfiMegaTrigger));
      trigger.addEventListener('focus', () => openMega(trigger.dataset.calinfiMegaTrigger));
      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        if (activeMenu === trigger.dataset.calinfiMegaTrigger) {
          closeMega();
          return;
        }

        openMega(trigger.dataset.calinfiMegaTrigger);
      });
    });

    panels.forEach((panel) => {
      panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    });

    header.addEventListener('mouseleave', scheduleClose);
    header.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!header.contains(document.activeElement)) closeMega();
      }, 0);
    });

    document.addEventListener('click', (event) => {
      if (activeMenu && !header.contains(event.target)) closeMega();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && activeMenu) closeMega();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth < 990) closeMega();
    });
  });
})();
